<main>
    <div class="app app-margin">
        <section class="nav-area-sm" [dir]="textDir">             
            <div class="row top-section padT15">
                <div class="md-12 lg-12 xl-12">
                    <section class="breadcrmb labeltxt">
                        <a [routerLink]="['/']" >{{'Home' | translate}}</a> 
                        <span class="eds-sep">&nbsp;/&nbsp;</span> 
                        <span class="active">{{'My classes' | translate}}</span>
                    </section>
                    <div class="row">
                        <div class="column lg-10">
                            <div class="marT10 header-title">{{'My classes' | translate}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div class="loading" *ngIf="!loaded"></div>
        <div class="app-container top-section hgt-80 project-overview-container marT20" *ngIf="loaded" [dir]="textDir">
            <div class="row">
                <div class="column lg-8 md-8 sm-12 proj-filters">
                    <div class="sm-3 marR10" *ngIf="gradeListToRender?.length">
                        <ngx-select-dropdown
						[(ngModel)]="filter.grade"
						[multiple]="false"
						[options]="gradeListToRender"
						[config]="gradeSelectConfig"></ngx-select-dropdown>
                    </div>
                </div>
                <div class="column lg-4 md-4 sm-12 flexEnd proj-search">
                    <!-- <div class="marR20 ">
                        <input type="text" class="with-icon font12 search" [(ngModel)]="filterQuery" placeholder="{{'Search by name' | translate}}" name="q">
                        <div class="suffix icon-inside"><i class="icon icon-search font16 eds-txt-blck"></i></div>
                    </div> -->

                    <div [ngClass]="textDir=='rtl'?'marL20':''">
                        <input type="text" class="with-icon inputwdith font12 search" [(ngModel)]="filterQuery" placeholder="{{'Search by name'| translate}}" name="q">
                        <div class="suffix icon-inside" [ngClass]="textDir=='rtl'?'marR38':''"><i class="icon icon-search"></i></div>
                    </div>
                    <div class="flexEnd">
                        <div class="grid-icon">
                            <label class="padT5" [ngClass]="{'selected':gridView}">
                                <input type="Radio" name="radio2text" value="gridView" (click)= 'setGrid()' checked="checked"><i class="icon icon-view-tiles"></i>
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <div class="list-icon">
                            <label class="padT5" [ngClass]="{'selected':!gridView}">
                                <input type="Radio" name="radio2text" value="listView" (click)= 'setList()' unchecked=""><i class="icon icon-view-list"></i>
                                <span class="checkmark"></span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row marT25">
                <div *ngIf="gridView" class="grid-align">
                    <div class="sm-4" *ngFor="let classRoom of NewClassRoomList|filterBy: ['grade.name']: filter?.grade?.name |filterBy: ['name','grade.name']: filterQuery | paginate: { itemsPerPage: noOfItems, currentPage: page } let i =index">
                        <!--<a class="cursor" (click)="manageGroupAndClass(classRoom)">-->
                        <div class="grade-card" (click)="manageGroupAndClass(classRoom)" style="cursor: pointer;">

                            <div class="row">
                                <div class="md-3">                                    
                                    <div *ngFor="let grades of gradeList; let j = index;" [ngClass]="[ grades?.name==classRoom?.grade?.name ? 'circle-text'+(j+1) : '']" [dir]="textDir"></div>
                                    <div class="cir-txt-pos" [dir]="textDir">{{classRoom?.name.substring(0,2)}}</div>
                                </div>
                                <div class="md-9">
                                    <div class="media-body marT25">
                                        
                                        <label class="form-title"> <a (click)="manageGroupAndClass(classRoom)" class="eds-txt-blck cur-poi">{{classRoom?.name}} Class</a></label>                                         
                                        <label class="labeltxt">{{classRoom?.grade?.name}}</label>
                                       
                                        <div class="flexStart marT25">
                                            <div class="flexStart">
                                                <div class="opac-5"><i class="icon icon-avatar" [ngClass]="textDir=='rtl'?'padL5':'padR5'"></i></div>
                                                <label class="labeltxt">{{classRoom?.count}} {{'student' | translate}}<span *ngIf="classRoom?.count>1">s</span></label>
                                            </div>
                                            <div class=" flexStart" [ngClass]="textDir=='rtl'?'marR15':'marL15'">
                                                <img src="assets/images/group-icon.PNG" width="18" height="14" style="margin-top:3px;" alt="">
                                                <ng-container *ngIf="classRoom?.groupcount>0;then isGroup;else isNoGroup"></ng-container>
                                                <ng-template #isGroup>
                                                    <label class="labeltxt" [ngClass]="textDir=='rtl'?'padR5':'padL5'"><span>{{classRoom?.groupcount}}</span> group<span *ngIf="classRoom?.groupcount !='1'">s</span></label>
                                                </ng-template>
                                                <ng-template #isNoGroup>
                                                    <label class="labeltxt" [ngClass]="textDir=='rtl'?'padR5':'padL5'">0 {{'groups' | translate}}</label>
                                                  </ng-template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="!gridView" class="sm-12">                            
                    <table class="table sortable selectable dashed">
                        <thead>
                            <tr>
                            <th class="col1-wid" (click)="sortBy('name')" [ngClass]="{'is-sortable':!this.isSorted || this.propertyName != 'name','desc':this.isSorted && this.propertyName == 'name' && this.orderType,'asc':this.isSorted && this.propertyName == 'name' && !this.orderType}">{{'Class' | translate}}</th>
                            <th class="col2-wid" (click)="sortBy('grade.name')" [ngClass]="{'is-sortable':!this.isSorted || this.propertyName != 'grade.name','desc':this.isSorted && this.propertyName == 'grade.name' && this.orderType,'asc':this.isSorted && this.propertyName == 'grade.name' && !this.orderType}">{{'Grade' | translate}}</th>
                            <th class="col3-wid" (click)="sortBy('count')" [ngClass]="{'is-sortable':!this.isSorted || this.propertyName != 'count','desc':this.isSorted && this.propertyName == 'count' && this.orderType,'asc':this.isSorted && this.propertyName == 'count' && !this.orderType}">{{'Students' | translate}}</th>
                            <th class="txtcenter col4-wid" (click)="sortBy('groupCount')" [ngClass]="{'is-sortable':!this.isSorted || this.propertyName != 'groupCount','desc':this.isSorted && this.propertyName == 'groupCount' && this.orderType,'asc':this.isSorted && this.propertyName == 'groupCount' && !this.orderType}">{{'Groups' | translate}}</th>
                            <th class ="col5-wid" >{{'Group names' | translate}}</th>                                   
                            </tr>
                        </thead>
                        <tbody>                            
                            <tr style="cursor: pointer;" *ngFor="let item of NewClassRoomList| orderBy: propertyNameSorting | filterBy: ['grade.name']: filter?.grade?.name | filterBy: ['name']: filterQuery | paginate: { itemsPerPage: noOfItems, currentPage: page }; let i = index"  (click)="manageGroupAndClass(item)"
                                app-ctl-list-view                                       
                                (viewDataEvent)="manageGroupAndClass(item)"
                                [objId]="item?._id"
                                [showlogo]="false"
                                [title]="item?.name"
                                [extrainfo2]=item?.grade?.name
                                [info1]="item?.count || '0'"
                                [info2]="item?.groupcount || '0'"
                                [info3]="groupNamesArr[item?._id] || '0'"
                                [row]="'true'"
                                [loopIndex]="i">
                            </tr>
                        </tbody>
                    </table>                            
                </div>
            </div>
        </div>
    </div>
</main>